import { Typography } from '@packages/ui/shared';
import { TableHeader, TableRow } from '@web/components/table';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';

const useCampaignsListStyles = createUseStyles({
    codeCell: {
        minWidth: '100px',
    },
    typeCatCell: {
        minWidth: '110px',
    },
    statusCell: {
        minWidth: '184px',
    },
    descriptionCell: {
        minWidth: '241px',
    },
    effectiveDateCell: {
        minWidth: '135px',
    },
    expirationDateCell: {
        minWidth: '135px',
    },
    progMilesCell: {
        minWidth: '109px',
    },
    repairOrderCell: {
        minWidth: '130px',
    },
});

export const CampaignsTableHeader = () => {
    const { t } = useTranslation();
    const classes = useCampaignsListStyles();

    const TABLE_HEADER_TITLES = [
        { title: 'Code', width: '9%', className: classes.codeCell },
        { title: 'Type & Category', width: '10%', className: classes.typeCatCell },
        { title: 'Status', width: '16%', className: classes.statusCell },
        { title: 'Description', width: '21%', className: classes.descriptionCell },
        { title: 'Effective Date', width: '12%', className: classes.effectiveDateCell },
        { title: 'Expiration Date', width: '12%', className: classes.expirationDateCell },
        { title: 'Prog. Miles', width: '9%', className: classes.progMilesCell },
        { title: 'Repair Order #', width: '11%', className: classes.repairOrderCell },
    ];

    return (
        <TableRow>
            {TABLE_HEADER_TITLES.map((header) => (
                <TableHeader key={header.title} width={header.width} className={header.className}>
                    <Typography variant="label">{t(header.title)}</Typography>
                </TableHeader>
            ))}
        </TableRow>
    );
};
